import { render, staticRenderFns } from "./site-internet-limoges.vue?vue&type=template&id=7b5e18ac&scoped=true&"
import script from "./site-internet-limoges.vue?vue&type=script&lang=js&"
export * from "./site-internet-limoges.vue?vue&type=script&lang=js&"
import style0 from "./site-internet-limoges.vue?vue&type=style&index=0&id=7b5e18ac&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5e18ac",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/app/components/Header.vue').default,Scroll: require('/app/components/Scroll.vue').default,TakeStock: require('/app/components/TakeStock.vue').default,FooterV2: require('/app/components/FooterV2.vue').default})
